import { cn } from '@/ui/utils';

export function Logo({ className }: { className?: string }) {
  return (
    <svg
      width="80"
      viewBox="0 0 93 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M82.3613 28C76.3921 28 72.1902 23.641 72.1902 17.2791C72.1902 10.9958 76.667 6.79382 82.4006 6.79382C88.5268 6.79382 92.0219 11.467 92.0219 16.8079C92.0219 17.5933 91.9826 18.3394 91.9041 18.8107H76.1173C76.6278 22.345 79.0626 24.5442 82.4398 24.5442C84.9532 24.5442 87.0738 23.4053 88.2126 21.5596L91.1187 23.4446C89.5478 26.115 86.4454 28 82.3613 28ZM76.1565 15.5119H88.2126C88.1734 12.6452 85.7386 10.2104 82.3613 10.2104C78.9447 10.2104 76.7456 12.4488 76.1565 15.5119Z"
        fill="currentColor"
      />
      <path
        d="M57.7879 27.4893L51.1904 7.3042H55.3531L61.5579 26.9003L67.527 7.3042H71.7683L65.1708 27.4893H57.7879Z"
        fill="currentColor"
      />
      <path d="M45.049 27.4895V0H48.976V27.4895H45.049Z" fill="currentColor" />
      <path
        d="M31.6421 28C25.4766 28 20.9998 23.6017 20.9998 17.3969C20.9998 11.2314 25.4766 6.79382 31.6421 6.79382C37.6898 6.79382 42.2845 11.2314 42.2845 17.3969C42.2845 23.6017 37.6898 28 31.6421 28ZM25.0054 17.3969C25.0054 21.5989 27.8329 24.4264 31.6421 24.4264C35.4514 24.4264 38.2789 21.5989 38.2789 17.3969C38.2789 13.352 35.4514 10.3675 31.6421 10.3675C27.8329 10.3675 25.0054 13.352 25.0054 17.3969Z"
        fill="currentColor"
      />
      <path
        d="M6.59748 27.4893L0 7.3042H4.16269L10.3675 26.9003L16.3366 7.3042H20.5778L13.9804 27.4893H6.59748Z"
        fill="currentColor"
      />
    </svg>
  );
}

export function LogoIcon({
  className,
  animated = false,
  breathe = true,
}: {
  className?: string;
  animated?: boolean;
  breathe?: boolean;
}) {
  return (
    <span
      className={cn(
        'inline-flex size-4 shrink-0 origin-center motion-reduce:animate-none data-active:animate-[logo-breathe_2s_ease-in-out_infinite]',
        className,
      )}
      data-active={animated && breathe ? '' : undefined}
    >
      <svg
        className="size-full origin-center motion-reduce:animate-none data-active:animate-[logo-spin_10s_linear_infinite]"
        data-active={animated ? '' : undefined}
        viewBox="0 0 532 532"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden
      >
        <path
          d="M257.543 214.904L210.728 4.56135L158.686 0L203.212 191.689L22.5081 114.473L17.9549 166.609L216.6 249.322L255.5 265.5L214.146 274.695L4.63937 319.083L0 372.202L191.653 327.522L114.194 509.451L166.237 514.013L249.172 314.113L265.5 275L273.854 316.169L318.436 527.352L371.461 532L326.557 338.688L509.492 416.857L514.131 363.738L313.575 282.802L275 265.5L315 257L527.447 211.264L532 159.128L338.605 204.212L415.951 22.5486L362.928 17.9009L282.776 217.228L266.5 256L257.543 214.904Z"
          fill="currentColor"
        />
      </svg>
    </span>
  );
}
